import "../../../styles/HelpModal.css";

import { FiMinus, FiPlus, FiX } from "react-icons/fi";
import React, { useState } from "react";

import Label from "../../atoms/Label";

const ShortcutsModal = ({ isOpen, onClose }) => {
	const [expandedSections, setExpandedSections] = useState(["windows"]);

	if (!isOpen) return null;

	const toggleSection = (sectionId) => {
		setExpandedSections((prev) => (prev.includes(sectionId) ? prev?.filter((id) => id !== sectionId) : [...prev, sectionId]));
	};

	const collapseAll = () => {
		setExpandedSections([]);
	};

	const expandAll = () => {
		setExpandedSections(sections?.map((section) => section.id));
	};

	const sections = [
		{
			id: "windows",
			title: "Keyboard Shortcuts: Windows",
			content: (
				<>
					<div className='section-description'>
						<p className='description-text'>The following keyboard shortcuts have been configured to navigate to important functions within the digital exam</p>
					</div>
					<div className='section-subtitle'>
						<p className='subtitle-text'>Keyboard Shortcuts for Multiple-Choice Questions</p>
					</div>
					<div className='shortcuts-table'>
						<div className='table-header'>
							<div className='header-cell'>Action</div>
							<div className='header-cell'>Shortcut</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Zoom In</div>
							<div>Control + Plus (+)</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Zoom Out</div>
							<div>Control + Minus (-)</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Zoom back to 100%</div>
							<div>Control + 0</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Back</div>
							<div>Control + Alt + B</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Next</div>
							<div>Control + Alt + X</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Help</div>
							<div>Control + Alt + H</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Open/Close Directions</div>
							<div>Control + Alt + Shift + D</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Hide/Show Timer or Close 5-Minute Message</div>
							<div>Control + Alt + T</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Pause Timer</div>
							<div>Control + Alt + P</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Mark for Review</div>
							<div>Control + Alt + V</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Annotate</div>
							<div>Control + Alt + A</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Open Annotation (w/Caret Browsing on)</div>
							<div>Shift + Enter</div>
						</div>
						<div className='table-row'>
							<div style={{ fontWeight: "700", fontSize: "14px" }}>Open / Close Reference Sheet</div>
							<div>Control + Alt + R</div>
						</div>
					</div>
				</>
			),
		},
	];

	return (
		<div className='modal-overlay'>
			<div className='modal'>
				<div className='modal-header'>
					<h2 className='modal-title'>Keyboard Shortcuts</h2>
					<div className='header-controls'>
						<button className='control-btn' onClick={collapseAll}>
							Collapse
						</button>
						<span className='separator'>|</span>
						<button className='control-btn' onClick={expandAll}>
							Expand
						</button>
						<button className='close-btn' onClick={onClose}>
							×
						</button>
					</div>
				</div>
				<div className='modal-content'>
					{sections?.map((section) => (
						<div key={section.id} className='section'>
							<div className='section-header' onClick={() => toggleSection(section.id)}>
								<h3>{section.title}</h3>
								<button className='toggle-btn'>{expandedSections.includes(section.id) ? <FiMinus /> : <FiPlus />}</button>
							</div>
							{expandedSections.includes(section.id) && <div className='section-content'>{section.content}</div>}
						</div>
					))}
				</div>
				<div className='modal-footer'>
					<button className='close-btn-large' onClick={onClose}>
						Close
					</button>
				</div>
			</div>
		</div>
	);
};

export default ShortcutsModal;
